import { defineNuxtPlugin } from "#app";
import { useRouter } from "vue-router";
import type { RouteLocationNormalized } from "vue-router";

export default defineNuxtPlugin(() => {
  const router = useRouter();
  router.afterEach((to: RouteLocationNormalized) => {
    const locale = to.path.split("/")[1];
    if (locale) localStorage.setItem("lastLocale", locale);
  });
});
